// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C6oL","badges":"styles_badges__3G42O"};